// extracted by mini-css-extract-plugin
module.exports = {"icon":"SadCalendar_icon__yAa7r"};